import styled from 'styled-components'

export const ArrowsContainer = styled.div`
  position: absolute;
  top: 50%;
  ${(props) => (props.direction === 'right' ? `right: 40px` : `left: 25px`)};
  height: 50px;
  width: 50px;

  cursor: pointer;

  transition: transform ease-in 0.1s;
  &:hover {
    transform: scale(1.1);
  }
  @media (min-width: 768px) and (max-width: 1000px) {
    ${(props) => (props.direction === 'right' ? `right: 40px` : `left: 10px`)};
    height: 40px;
    width: 40px;
  }

  @media (max-width: 768px) {
    visibility: hidden;
    z-index: 10;
  }
`

export const ArrowImage = styled.img`
  &:focus {
    outline: 0;
  }
`
